export const GET_ALL_PAUSAS = 'GET_ALL_PAUSAS'
export const GET_ALL_RAMAIS = 'GET_ALL_RAMAIS'
export const GET_ALL_FILAS = 'GET_ALL_FILAS'
export const GET_ALL_OPERADORES = 'GET_ALL_OPERADORES'
